export const LOCALE = 'en';
export const fullDateFormat = { year: 'numeric', month: 'short', day: 'numeric' };
export const todayTimeFormat = { hour12: false, hour: '2-digit', minute: '2-digit' };
